import Api from "@/services/Api";
import {formatCurrency, isDev} from "@/helpers";
import WebFacebookLogin from "@/services/WebFacebookLogin";
import Bugsnag from '@bugsnag/js'

export default {
  install(Vue) {

    const DESKTOP_MIN_WIDTH = 480;

    /**
     * Web observer
     */
    Vue.prototype.$web = (() => {
      let WebObserver = new Vue({
        data() {
          return {
            isDesktop: false
          }
        },
      });

      WebObserver.isDesktop = window.innerWidth > DESKTOP_MIN_WIDTH;

      window.addEventListener('resize', () => {
        WebObserver.$set(WebObserver, 'isDesktop', window.innerWidth > DESKTOP_MIN_WIDTH);
      });

      return WebObserver;
    })();

    /**
     * Alert wrapper
     */
    Vue.prototype.$alert = function (message) {
      let messageContent = typeof message === 'string' ? message : message.message;
      alert(messageContent)
    };

    /**
     * Apis
     */
    Vue.prototype.$api = new Api;

    /**
     * Is user online?
     * @returns {boolean}
     */
    Vue.prototype.$isOnline = function () {
      return navigator.onLine;
    };

    /**
     * Load html and populate template with props.
     *
     * @param {string} source
     * @param {object} props
     * @returns {string}
     */
    Vue.prototype.$loadHtml = function (source, props) {
      let Handlebars = require('handlebars');

      Handlebars.registerHelper('ifEquals', function (arg1, arg2, options) {
        return (arg1 == arg2) ? options.fn(this) : options.inverse(this);
      });

      Handlebars.registerHelper('formatCurrency', formatCurrency);

      let template = Handlebars.compile(source);

      return template(props);
    };

    /**
     * Api
     */
    Vue.prototype.$api = new Api;

    /**
     * Facebook login
     * @returns {Promise<string>}
     */
    Vue.prototype.$facebookLogin = async function () {
      const api = await WebFacebookLogin();
      let response = await api.login();

      return response.accessToken;
    };

    // Is Online?
    Vue.prototype.$bugsnag = {
      notify(data) {
        if (!isDev()){
          Bugsnag.notify(data);
        } else {
          console.warn(data);
        }
      }
    };

    // Alert
    Vue.prototype.$registerEvent = function (action, event_label) {
      if (window.gtag) {
        window.gtag('event', action, {
          'event_category': 'Web',
          event_label
        });
      } else {
        console.log(`window.gtag('event', '${action}', {'event_category': 'Web', event_label:'${event_label}');`)
      }
    };

    Vue.prototype.$registerFacebookEvent = function (event) {
      if (window.fbq){
        window.fbq('track', event)
      } else {
        console.log(`fbq('track', '${event}')`)
      }
    }

    Vue.prototype.$registerConversion = function () {
      if (window.gtag) {
        window.gtag('event', 'conversion', {'send_to': process.env.VUE_APP_AW_KEY});
      } else {
        console.log(`gtag('event', 'conversion', {'send_to': '${process.env.VUE_APP_AW_KEY}'});`)
      }
    };

  }
}